import {
  input,
  inject,
  Renderer2,
  DestroyRef,
  ViewChild,
  ElementRef,
  afterNextRender,
  Component,
  ChangeDetectionStrategy
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { fromFetch } from 'rxjs/fetch';
import { Observable, mergeMap, tap, catchError, EMPTY } from 'rxjs';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [],
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ErrorComponent {
  readonly errorType = input<string>('');

  readonly #renderer = inject(Renderer2);
  readonly #destroyRef = inject(DestroyRef);

  @ViewChild('errorContainer')
  errorContainer!: ElementRef;

  hasError = false;

  constructor() {
    afterNextRender(() => {
      this.loadTemplate()
        .pipe(takeUntilDestroyed(this.#destroyRef))
        .subscribe();
    });
  }

  private loadTemplate(): Observable<string> {
    return fromFetch(`/assets/error-pages/${this.errorType()}.html`).pipe(
      mergeMap(res => {
        if (!res.ok) {
          throw new Error();
        }

        return res.text();
      }),
      tap(data => {
        this.processTemplate(data);
      }),
      catchError(() => {
        this.hasError = true;
        return EMPTY;
      })
    );
  }

  private processTemplate(data: string): void {
    const div = this.#renderer.createElement('div') as HTMLElement;
    this.#renderer.setProperty(div, 'innerHTML', data);
    this.#renderer.appendChild(this.errorContainer.nativeElement, div);
  }
}
